export default "__VITE_ASSET__af1353ec__"